import { type FeatureModule } from '@store/features/types';

export const patientDeduplicationFeature: FeatureModule = {
  id: 'patientDeduplication',
  name: 'Patient Deduplication',
  dependencies: [],
  reducers: {},
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {},
  cleanup: _store => {},
};
